import { ComputerModel, ComputerType } from "../types/computer";

export interface ComputerDefinition {
  model: ComputerModel;
  type: ComputerType;
  processing: number;
  techLevel: number;
  baseCost: number;
  description: string;
}

export const COMPUTERS: Record<ComputerModel, ComputerDefinition> = {
  "Computer/5": {
    model: "Computer/5",
    type: "standard",
    processing: 5,
    techLevel: 7,
    baseCost: 30000,
    description: "Basic ship computer with minimal processing power",
  },
  "Computer/10": {
    model: "Computer/10",
    type: "standard",
    processing: 10,
    techLevel: 9,
    baseCost: 160000,
    description: "Standard ship computer with moderate processing power",
  },
  "Computer/15": {
    model: "Computer/15",
    type: "standard",
    processing: 15,
    techLevel: 11,
    baseCost: 2000000,
    description: "Advanced ship computer with good processing power",
  },
  "Computer/20": {
    model: "Computer/20",
    type: "standard",
    processing: 20,
    techLevel: 12,
    baseCost: 5000000,
    description: "High-performance ship computer",
  },
  "Computer/25": {
    model: "Computer/25",
    type: "standard",
    processing: 25,
    techLevel: 13,
    baseCost: 10000000,
    description: "Military-grade ship computer",
  },
  "Computer/30": {
    model: "Computer/30",
    type: "standard",
    processing: 30,
    techLevel: 14,
    baseCost: 20000000,
    description: "Cutting-edge ship computer",
  },
  "Computer/35": {
    model: "Computer/35",
    type: "standard",
    processing: 35,
    techLevel: 15,
    baseCost: 30000000,
    description: "State-of-the-art ship computer",
  },
  "Core/40": {
    model: "Core/40",
    type: "core",
    processing: 40,
    techLevel: 9,
    baseCost: 45000000,
    description: "Basic computer core for capital ships",
  },
  "Core/50": {
    model: "Core/50",
    type: "core",
    processing: 50,
    techLevel: 10,
    baseCost: 60000000,
    description: "Standard computer core for capital ships",
  },
  "Core/60": {
    model: "Core/60",
    type: "core",
    processing: 60,
    techLevel: 11,
    baseCost: 75000000,
    description: "Advanced computer core for capital ships",
  },
  "Core/70": {
    model: "Core/70",
    type: "core",
    processing: 70,
    techLevel: 12,
    baseCost: 80000000,
    description: "High-performance computer core",
  },
  "Core/80": {
    model: "Core/80",
    type: "core",
    processing: 80,
    techLevel: 13,
    baseCost: 95000000,
    description: "Military-grade computer core",
  },
  "Core/90": {
    model: "Core/90",
    type: "core",
    processing: 90,
    techLevel: 14,
    baseCost: 120000000,
    description: "Cutting-edge computer core",
  },
  "Core/100": {
    model: "Core/100",
    type: "core",
    processing: 100,
    techLevel: 15,
    baseCost: 130000000,
    description: "State-of-the-art computer core",
  },
} as const;

export const COMPUTER_OPTIONS = {
  jumpControl: {
    name: "Jump Control Specialisation (/bis)",
    description:
      "Processing score increased by +5 for Jump Control programs only",
    costMultiplier: 1.5, // +50%
  },
  hardened: {
    name: "Hardened Systems (/fib)",
    description: "Immune to Ion weapons and electromagnetic pulse attacks",
    costMultiplier: 1.5, // +50%
  },
  both: {
    name: "Both Options",
    description: "Jump Control Specialisation and Hardened Systems",
    costMultiplier: 2.0, // +100%
  },
} as const;

export const COMPUTER_RULES = {
  maxComputers: 2,
  backupMustBeLower: true,
  noSimultaneousOperation: true,
  noTonnage: true,
} as const;
